import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import CustomInput from "../CustomInput/Input";

const PasswordInput = ({ visible, onToggleVisibility, ...inputProps }) => (
  <CustomInput
    isPassword
    type={visible ? "text" : "password"}
    iconRender={() =>
      visible ? (
        <EyeInvisibleOutlined onClick={onToggleVisibility} />
      ) : (
        <EyeOutlined onClick={onToggleVisibility} />
      )
    }
    {...inputProps}
  />
);

export default PasswordInput;
